import React, { useEffect, useState } from "react";
import SideMenu from "../Pages/SideMenu";
import Header from "../Pages/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Pages/Footer";
import Logout from "../Pages/Logout";
import { Button } from "react-bootstrap";
import { CustomTable } from "../CustomTable";
import { addMainStoreMaster, getMainStoreMaster, } from "../Utilities/URLCONSTANTS";
import axios from "axios";
import { CustomModal } from "../CustomModal";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import { formatRoleName, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";

export const SiteMaster = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [name, setName] = useState()
    const [storeLocationname, setStoreLocationname] = useState()
    const [storeLocationnameError, setStoreLocationnameError] = useState('')
    const [contactPersonError, setContactPersonError] = useState('')
    const [contactPerson, setContactPerson] = useState()
    const [contactMobileNo, setContactMobileNo] = useState()
    const [contactMobileNoError, setContactMobileNoError] = useState('')
    const [status, setStatus] = useState()
    const [id, setId] = useState()
    const [saveEdit, setSaveEdit] = useState()
    const [responseMsg, setResponseMsg] = useState()
    const [msgPopup, setMsgPopup] = useState(false)
    const [error, setError] = useState('')
    const [statusError, setStatusError] = useState('')
    const [loader, setLoader] = useState(false)

    const getData = async () => {
        const URL = getMainStoreMaster;
        const headers = await GetApiHeaders()
        try {
            setLoader(true)
            const response = await axios.get(URL, { headers })
            console.log(response)
            setData(response.data.response.MainStore)
            setLoader(false)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const headersData = [
        {
            field: "name",
            header: "Main Site",
        },

        {
            field: "storeLocation",
            header: "Store Location",
        },
        {
            field: "contactPerson",
            header: "Contact Person",
        },
        {
            field: "contactMobileNumber",
            header: "Contact Mobile No",
        },

        {
            field: "status",
            header: "Status",
        },
    ];

    const onEditClicked = (data) => {
        console.log(data);

        setSaveEdit('Update')
        setId(data.id)
        setShowModal(true)
        setName(data.name)
        setStatus(data.status)
        setStoreLocationname(data.storeLocation)
        setContactMobileNo(data.contactMobileNumber)
        setContactPerson(data.contactPerson)
        setError('')
        setStoreLocationnameError('')
        setContactPersonError('')
        setContactMobileNoError('')
        setStatusError('')
    }

    const handleModalOpen = () => {
        setSaveEdit('Submit')
        setShowModal(true)
        setName('')
        setStatus('')
        setStoreLocationname('')
        setContactMobileNo('')
        setContactPerson('')
        setError('')
        setStoreLocationnameError('')
        setContactPersonError('')
        setContactMobileNoError('')
        setStatusError('')

    }
    const handleCancel_new = () => {
        setShowModal(false)
    }

    const handleName = (e) => {
        const input = e.target.value
        // const alphabeticInput = Input.replace(/[^a-zA-Z ]/g, "");
        const formattedInput = formatRoleName(input);
        setName(formattedInput)
        if (input) {
            setError('')
        }
    }
    const handleStoreKication = (e) => {
        const Input = e.target.value
        // const alphabeticInput = Input.replace(/[^a-zA-Z ]/g, "");
        const formattedInput = formatRoleName(Input);
        setStoreLocationname(formattedInput)
        if (Input) {
            setStoreLocationnameError('')
        }
    }

    const handlePerson = (e) => {
        const Input = e.target.value
        // const alphabeticInput = Input.replace(/[^a-zA-Z ]/g, "");
        const formattedInput = formatRoleName(Input);
        setContactPerson(formattedInput)
        if (Input) {
            setContactPersonError('')
        }
    }
    const handleMobileNo = (e) => {
        const input = e.target.value;
        let result = input.replace(/[^0-9]/g, "");
        if (input) {
            setContactMobileNoError("");
        }
        if (result.length > 10) {
            result = result.substr(0, 10);
        }

        if (/^[6-9]/.test(result)) {
            setContactMobileNo(result);
        } else {
            setContactMobileNo("");
        }
    }


    const handleStatus = (e) => {
        const statusInput = e.target.value
        setStatus(statusInput)
        if (statusInput) {
            setStatusError('')
        }
    }

    const handleSubmitData = async () => {
        if (!status) {
            setStatusError("Select Status")
        }

        if (!name) {
            setError('Enter Main Site Name')
        }
        if (!storeLocationname) {
            setStoreLocationnameError('Enter Store Location')
        }
        if (!contactPerson) {
            setContactPersonError('Enter Contact Person')
        }
        // if (!contactMobileNo) {
        //     setContactMobileNoError('Enter Mobile No')
        // }

        if (!contactMobileNo || contactMobileNo.length < 10) {
            setContactMobileNoError(
                !contactMobileNo ? 'Enter Mobile Number' : 'Enter a valid 10-digit Mobile Number'
            );
            return;
        }
        const apiUrl = addMainStoreMaster;
        const headers = await GetApiHeaders()
        const reqData = {
            Id: saveEdit === "Submit" ? "0" : id.toString(),
            name: name,
            storeLocation: storeLocationname,
            userID: headers.userId,
            contactPerson: contactPerson,
            contactMobileNumber: contactMobileNo,
            status: status,
        }

        try {
            if (name !== '' && status !== '' && storeLocationname !== '' && contactMobileNo !== '') {
                setLoader(true)
                const response = await axios.post(apiUrl, reqData, { headers })
                if (response.data.statusCode == 200 || response.data.status == 500) {
                    setShowModal(false)
                    setMsgPopup(true)
                    setResponseMsg(response.data.response);
                    setLoader(false)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleOk = () => {
        setMsgPopup(false)
        getData()
    }

    return (
        <body id="page-top">
            <div id="wrapper">
                <SideMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header />
                        <div>
                            <div className="container-fluid">
                                <div className="card border-0">
                                    <div className="card-body pt-0 pl-1">
                                        <h5 className="Roles_text">  Master</h5>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-0 Sub_role_text">Main Site Master</h6>
                                            </div>
                                            <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Add Site  Master"  >
                                                <Button variant="primary" className="buttons" onClick={handleModalOpen}  >
                                                    <FontAwesomeIcon icon={faPlus} className="plus_icon mr-1" />
                                                    Add
                                                </Button>
                                            </span>
                                        </div>
                                        <div className="mcrc_hrline"></div>
                                        <CustomTable
                                            headers={headersData}
                                            data={data}
                                            showAction={true}
                                            showButtons={true}
                                            ActionEdit={true}
                                            onEditClicked={onEditClicked}
                                            ActionName={"Action"}
                                            loader={loader}
                                            FileName={'Site'}
                                        />

                                        <CustomModal
                                            showModal={showModal}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Site Master'}
                                            buttonText={saveEdit}
                                            handleSubmitData={handleSubmitData}
                                            childrens={
                                                <div>
                                                    <div className='row'>
                                                        <div className='col-md-6 col-12'>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Main Site Name   <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " placeholder='Enter Site Name' value={name} onChange={handleName} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {error}</span>
                                                        </div>
                                                        <div className='col-md-6 col-12' style={{ marginTop: "-1px" }}>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Store Location   <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " placeholder='Enter Store Location' value={storeLocationname} onChange={handleStoreKication} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {storeLocationnameError}</span>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-6 col-12' >
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Contact Person   <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " placeholder='Enter Contact Person' value={contactPerson} onChange={handlePerson} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {contactPersonError}</span>
                                                        </div>
                                                        <div className='col-md-6 col-12' style={{ marginTop: "-1px" }}>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Contact Mobile No   <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " placeholder='Enter Mobile No' value={contactMobileNo} onChange={handleMobileNo} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {contactMobileNoError}</span>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="statusDropdown"
                                                                className="form-label text-sm font-weight-600 mt-1"
                                                            >
                                                                Status <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <Select
                                                                inputId="statusDropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Status"
                                                                isClearable
                                                                value={
                                                                    [
                                                                        { value: "1", label: "Active" },
                                                                        { value: "0", label: "InActive" },
                                                                    ].find((option) => option.value === status) || null
                                                                }
                                                                options={[
                                                                    { value: "1", label: "Active" },
                                                                    { value: "0", label: "InActive" },
                                                                ]}
                                                                onChange={(selectedOption) =>
                                                                    handleStatus({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                            <span style={{ color: "red" }}>
                                                                {statusError}
                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            }
                                        />
                                        <CustomModal
                                            showModal={msgPopup}
                                            msgPopup={msgPopup}
                                            handleOk={handleOk}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Site Master'}
                                            childrens={<div className="p-4 d-flex justify-content-center" style={{ fontSize: "18px", color: "#4A7729", fontWeight: 500 }}>{responseMsg}</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
            <Logout />
        </body>
    )
}